import ParameterScriptRequest from './rule-parameter-script-request';

export default class RuleSimulateScriptRequest {
  data: any;

  ruleId: string;

  parameters: ParameterScriptRequest[] = [];

  constructor(obj: any = {}) {
    this.ruleId = obj.id || '';
    this.parameters = ParameterScriptRequest.ofList(obj.parameters);
  }

  public static of(obj: any = {}): RuleSimulateScriptRequest {
    return new RuleSimulateScriptRequest(obj || {});
  }

  public static ofList(obj: any[]): RuleSimulateScriptRequest[] {
    return obj.map(this.of);
  }
}
